import React, { useState } from 'react';
import GetSelectMonths from '../../Dropdowns/getSelectMonth';
import GetSelectYears from '../../Dropdowns/getSelectYear';
import Sales_Data_Summary from './Sales_Data_Summary';

const Sales_Data_Interface = ({ heading }) => {

    const [renderContent, setRenderContent] = useState(null);
    const [loading, setLoading] = useState(true);

    const handleLoadingChange = (isLoading) => {
        setLoading(isLoading);
    };

    const handleSubmit = () => {
        const month = document.getElementById('sales_month').value;
        const year = document.getElementById('sales_year').value;

        if (month == 0 || month == null || month === '') {
            alert('Please select Month');
        } else if (year == 0 || year == null || year === '') {
            alert('Please select Year');
        } else {
            setRenderContent(null);
            setTimeout(() => {
                setRenderContent(
                    <Sales_Data_Summary
                        month={month}
                        year={year}
                        heading={heading}
                    />
                );
            }, 0);
        }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="30%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={4}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Month</td>
                                    <td><GetSelectMonths input_id={"sales_month"} onLoadingChange={handleLoadingChange} /></td>
                                    <td>Year</td>
                                    <td><GetSelectYears input_id={'sales_year'} onLoadingChange={handleLoadingChange} /></td>
                                </tr>
                                <tr>
                                    <td colSpan={4} align="center">
                                        <button onClick={handleSubmit} className="button button2" disabled={loading}>
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    <div id="salesDataDetails">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default Sales_Data_Interface;


